import { render, staticRenderFns } from "./Domain-Selector.vue?vue&type=template&id=0f2327f0&lang=pug"
import script from "./Domain-Selector.vue?vue&type=script&setup=true&lang=ts"
export * from "./Domain-Selector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports